// extracted by mini-css-extract-plugin
export var aircallIframe = "_kd-3";
export var fabContainer = "_kd-5";
export var fabRinging = "_kd-6";
export var loadingOverlay = "_kd-4";
export var pulse = "_kd-7";
export var widgetContent = "_kd-2";
export var widgetPanel = "_kd-0";
export var widgetPanelExpanded = "_kd-1";